import { camelizeKeys } from 'humps';
import { get } from '@namespace/helpers';

export const getBsActiveDepositBonuses = () =>
  get('/service/prewager/campaigns/deposit')
    .then(camelizeKeys)
    .then(({ status, data }) => (status === 'success' ? data : {}));
